// ======================================================================
// File Name       : Header
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';

const Header = function (props) {
  return (
    <header className="headerTitle margin-top-15">
      {`${props.name}`}
    </header>
  );
};

export default Header;
